import { SET_POST_OFFICES } from '../../constants/ActionTypes';

export const setPostOffices = postOffice => {
  return {
    type: SET_POST_OFFICES,
    payload: postOffice,
  };
};
